import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const mudraRoomImages = [
  "/images/Mudra Edited/DSC02016.webp",
  "/images/Mudra Edited/DSC02032.webp",
  "/images/Mudra Edited/DSC02097.webp",
  "/images/Mudra Edited/DSC02074.webp",
  "/images/Mudra Edited/DSC02079.webp",
  "/images/Mudra Edited/DSC02127.webp"
];
const MudraRooms = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Zimmer in Hiru Mudra
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Doppelzimmer zum Einswerden mit dem Meer
                    </h2>
                    <p className="mt-5 font-mulish text-base leading-8 text-gray-600 sm:text-lg">
                        Genießen Sie eine ruhige und entspannte Zeit in nur 11 privaten Zimmern, umgeben vom Klang der Wellen.
                    </p>
                </div>

                <article className="mx-auto mt-12 grid max-w-7xl overflow-hidden rounded-[26px] bg-[#fbfaf7] shadow-[0_22px_65px_rgba(16,38,26,0.1)] lg:grid-cols-[1.1fr_0.9fr]">
                    <button
    type="button"
    className="group relative block aspect-[4/3] min-h-[320px] w-full overflow-hidden bg-[#f3eee7] text-left lg:aspect-auto lg:min-h-[560px]"
    onClick={() => setIsGalleryOpen(true)}
    aria-label="Zimmerfotos von Hiru Mudra Doppelzimmer anzeigen"
  >
                        <img
    src={mudraRoomImages[0]}
    alt="Hiru Mudra Doppelzimmer"
    className="object-cover transition-transform duration-700 group-hover:scale-[1.04]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
                        <div className="absolute inset-x-6 bottom-6 flex items-end justify-between gap-4 text-white sm:inset-x-8">
                            <div>
                                <p className="font-mulish text-xs font-semibold uppercase tracking-[0.22em] text-amber-200">Alle 11 Zimmer</p>
                                <h3 className="mt-2 font-serif text-3xl font-semibold sm:text-4xl">Doppelzimmer</h3>
                            </div>
                            <span className="rounded-full bg-white/20 px-3 py-2 text-xs font-semibold backdrop-blur-md">Bilder ansehen</span>
                        </div>
                    </button>

                    <div className="p-6 sm:p-8 lg:p-10">
                        <p className="font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                            In diesem dreistöckigen Gebäude direkt am wunderschönen Strand erstreckt sich ein ruhiger Privatraum mit nur 11 Zimmern. Jedes Zimmer liegt am Meer und bietet von der eigenen Terrasse aus die unmittelbare Nähe zum Wellengang.
                        </p>
                        <p className="mt-5 font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                            Der großzügige Innenraum von etwa 34 m² ist mit sorgfältigem Komfort ausgestattet, damit Sie den Alltag für einen Moment vergessen und ganz in die Gegenwart eintauchen können. Ein Dachterrasse und ein von Meerluft durchströmter Garten ergänzen diese entspannte Atmosphäre.
                        </p>
                        <ul className="mt-6 space-y-2 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                            <li>Zimmerausstattung: Deckenventilator, Klimaanlage und Moskitonetz inklusive.</li>
                            <li>Komfort: Eigenes Badezimmer, Föhn, Safe, Telefon und kostenloses Wi‑Fi.</li>
                            <li>Jedes Zimmer verfügt über einen privaten Balkon mit wunderschönem Meerblick.</li>
                        </ul>
                        <button
    type="button"
    onClick={() => setIsGalleryOpen(true)}
    className="mt-7 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
  >
                            Zimmerbilder ansehen
                        </button>
                    </div>
                </article>
            </div>

            <Lightbox
    open={isGalleryOpen}
    close={() => setIsGalleryOpen(false)}
    slides={mudraRoomImages.map((image) => ({ src: image }))}
    plugins={[Thumbnails, Zoom]}
    thumbnails={{ position: "bottom", border: 0, vignette: true }}
    zoom={{ maxZoomPixelRatio: 3 }}
    carousel={{ finite: false }}
  />
        </section>;
};
export default MudraRooms;
